import { Component, Input, Output,EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { TypesService } from '../../../services/types.service';
import { CustomfieldsService } from 'projects/core/src/lib/customfields.service';
import { Model } from 'projects/core/src/include/model';
import { Globals } from 'projects/core/src/globals';
import { UsersService } from 'projects/ratingo-backend/src/app/services/users.service';
import { ActivatedRoute } from '@angular/router';
import { Field } from 'projects/core/src/include/structures';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-field-setting',
  templateUrl: './field-setting.component.html',
  styleUrl: './field-setting.component.css'
})
export class FieldSettingComponent extends Model<Field>  implements OnInit,OnChanges {
  @ViewChild("modalAccessList")
  modalAccessList:any;
  modalAccessListRef:any;
  

  @Input()
  j:number=-1;

  @Input()
  i:number=-1;
  
  @Input()
  f: any;

  

  @Input()
  fields:any[]=[];

  @Input()
  sections:any[]=[];



  @Output()
  onMoveToSection:EventEmitter<any>=new EventEmitter();

  @Output()
  onRemove:EventEmitter<any>=new EventEmitter();

  @Output()
  onDuplicate:EventEmitter<any>=new EventEmitter();

  @Output()
  onMoveField:EventEmitter<any>=new EventEmitter();

    customfields:any=[];
    usersgroups:any=[];
    colors:any=["Rosso","Giallo","Arancione","Verde",,"Blu","Indaco","Viola"];
    qualifications:any=["Nessuno","Licenza Elementare","Licenza Media","Diploma di Scuola Superiore","Laurea Triennale","Laurea Magistrale","Master Universitario"];
    months:any=["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];
    italian_regions:any=["Piemonte","Valle d'Aosta","Lombardia"," Trentino-Alto Adige"," Veneto","Friuli-Venezia Giulia","Liguria","Emilia-Romagna","Toscana","Umbria","Marche","Lazio","Abruzzo","Molise","Campania","Puglia","Basilicata","Calabria","Sicilia","Sardegna"];
    italian_country:any=["Agrigento","Alessandria","Ancona","Aosta","Arezzo","Ascoli Piceno","Asti","Avellino","Bari","Barletta-Andria-Trani","Belluno","Benevento","Bergamo","Biella","Bologna","Bolzano","Brescia","Brindisi","Cagliari","Caltanissetta","Campobasso","Caserta","Catania","Catanzaro","Chieti","Como","Cosenza","Cremona","Crotone","Cuneo","Enna","Fermo","Ferrara","Firenze","Foggia","Forlì-Cesena","Frosinone","Genova","Gorizia","Grosseto","Imperia","Isernia","L’aquila","La spezia","Latina","Lecce","Lecco","Livorno","Lodi","Lucca","Macerata","Mantova","Massa-Carrara","Matera","Messina","Milano","Modena","Monza e Brianza","Napoli","Novara","Nuoro","Oristano","Padova","Palermo","Parma","Pavia","Perugia","Pesaro e Urbino","Pescara","Piacenza","Pisa","Pistoia","Pordenone","Potenza","Prato","Ragusa","Ravenna","Reggio Calabria","Reggio Emilia","Rieti","Rimini","Roma","Rovigo","Salerno","Sassari","Savona","Siena","Siracusa","Sondrio","Sud Sardegna","Taranto","Teramo","Terni","Torino","Trapani","Trento","Treviso","Trieste","Udine","Varese","Venezia","Verbano-Cusio-Ossola","Vercelli","Verona","Vibo valentia","Vicenza","Viterbo"];
    nations:any=["Andorra","Emirati Arabi Uniti","Afghanistan","Antigua e Barbuda","Anguilla","Albania","Armenia","Antille Olandesi","Angola","Antartide","Argentina","Samoa americane","Austria","Australia","Aruba","Azerbaigian","Bosnia ed Erzegovina","Barbados","Bangladesh","Belgio","Burkina Faso","Bulgaria","Bahrein","Burundi","Benin","Bermuda","Brunei","Bolivia","Brasile","Bahamas","Bhutan","Isola Bouvet","Botswana","Bielorussia","Belize","Canada","Isole Cocos (Keeling)","Congo (RDC)","Repubblica Centrafricana","Congo (Repubblica)","Svizzera","Costa d'Avorio","Isole Cook","Cile","Camerun","Cina","Colombia","Costa Rica","Cuba","Capo Verde","Isola Christmas","Cipro","Repubblica Ceca","Germania","Gibuti","Danimarca","Dominica","Repubblica Dominicana","Algeria","Ecuador","Estonia","Egitto","Sahara occidentale","Eritrea","Spagna","Etiopia","Finlandia","Figi","Isole Falkland (Isole Malvine)","Micronesia","Isole Fær Øer","Francia","Gabon","Regno Unito","Grenada","Georgia","Guyana francese","Guernsey","Ghana","Gibilterra","Groenlandia","Gambia","Guinea","Guadalupa","Guinea Equatoriale","Grecia","Georgia del Sud e Sandwich Australi","Guatemala","Guam","Guinea-Bissau","Guyana","Striscia di Gaza","Hong Kong","Isole Heard e McDonald","Honduras","Croazia","Haiti","Ungheria","Indonesia","Irlanda","Israele","Isola di Man","India","Territorio britannico dell'Oceano Indiano","Iraq","Iran","Islanda","Italia","Jersey","Giamaica","Giordania","Giappone","Kenya","Kirghizistan","Cambogia","Kiribati","Comore","Saint Kitts e Nevis","Corea del Nord","Corea del Sud","Kuwait","Isole Cayman","Kazakistan","Laos","Libano","Saint Lucia","Liechtenstein","Sri Lanka","Liberia","Lesotho","Lituania","Lussemburgo","Lettonia","Libia","Marocco","Monaco","Moldavia","Montenegro","Madagascar","Isole Marshall","Macedonia del Nord","Mali","Myanmar","Mongolia","Macao","Isole Marianne settentrionali","Martinica","Mauritania","Montserrat","Malta","Mauritius","Maldive","Malawi","Messico","Malaysia","Mozambico","Namibia","Nuova Caledonia","Niger","Isola Norfolk","Nigeria","Nicaragua","Paesi Bassi","Norvegia","Nepal","Nauru","Niue","Nuova Zelanda","Oman","Panama","Perù","Polinesia francese","Papua Nuova Guinea","Filippine","Pakistan","Polonia","Saint-Pierre e Miquelon","Isole Pitcairn","Portorico","Territori palestinesi","Portogallo","Palau","Paraguay","Qatar","Riunione","Romania","Serbia","Russia","Ruanda","Arabia Saudita","Isole Salomone","Seychelles","Sudan","Svezia","Singapore","Sant'Elena","Slovenia","Svalbard e Jan Mayen","Slovacchia","Sierra Leone","San Marino","Senegal","Somalia","Suriname","São Tomé e Príncipe","El Salvador","Siria","Swaziland","Isole Turks e Caicos","Ciad","Terre australi francesi","Togo","Thailandia","Tagikistan","Tokelau","Timor Est","Turkmenistan","Tunisia","Tonga","Turchia","Trinidad e Tobago","Tuvalu","Taiwan","Tanzania","Ucraina","Uganda","Altre isole americane del Pacifico","Stati Uniti","Uruguay","Uzbekistan","Città del Vaticano","Saint Vincent e Grenadine","Venezuela","Isole Vergini Britanniche","Isole Vergini Americane","Vietnam","Vanuatu","Wallis e Futuna","Samoa","Kosovo","Yemen","Mayotte","Sudafrica","Zambia","Zimbabwe"];
  
    default_file_params=[
      {"name":"subdirectory","value":"","label":"Nome della sottocartella (da creare)","type":"text","description":"utilizzare le keyword {{nome campo}} per sostituire i campi del record"},
      {"name":"default_filename","value":"","label":"Nome del file (predefinito)","type":"text","description":"utilizzare le keyword {{nome campo}} per sostituire i campi del record, oppure [filename] per inserire il nome del file che si sta caricando"},
      {"name":"multiple","value":"false","label":"Permetti di aggiungere più file","type":"boolean"}    
    ];
  
    default_photo_params=[
      {"name":"multiple","value":"false","label":"Permetti di aggiungere più foto","type":"boolean"}    
    ];
  
    default_addresses_params=[
      {"name":"id_type","value":"","label":"ID della tipologia di default","type":"text"}    
    ];
  
    default_documents_params=[
      {"name":"id_type","value":"","label":"ID della tipologia di default","type":"text"}    
    ];
  
    type_addresses=[];
    param_selected="";
    constructor(
      private route1:ActivatedRoute,
      private typesService:TypesService,
      private customfieldsService:CustomfieldsService,
      private usersService:UsersService,
      private modalService:NgbModal
    ) { 
      super(route1,null);

    }
  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(()=>{
       this.f.access_mode=this.parseAccess(this.f.access);
       
       try{
        if(this.f.type=='select' || this.f.type=="table"){
          if(typeof(this.f.params)=='string')
           this.f.params=JSON.parse(this.f.params);
        }


       }catch{
        this.f.params=[];
       }
    },500)
  }
  
    ngOnInit(): void {
      
      if(this.i==-1 && this.j==-1){
        this.f['expand']=true;
      }
      this.customfieldsService.getCustomFields("",true).subscribe((result)=>{
        this.customfields=result;
      });

      
      this.usersService.getGroups().subscribe((result)=>{
        this.usersgroups=result;
      })

     
      
     
       
          
      
      

    }
  

  renameField(field:any){
    field.name=field.label;
    if(field.name=="")
      field.name='field'+field.id
    field.name = field.name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_')         // Sostituisce gli spazi interni con '_'
    .replace(/[^a-z0-9_]/g, '')    // Mantiene SOLO lettere, numeri e '_' (elimina simboli/punteggiatura)
    .substring(0, 64)             // Limite massimo di 64 caratteri per MySQL
    .replace(/_+$/, '');
  }

  suggestParams(field:any){
    switch(field.type){
      case "select":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=[];
        else
          field.params=JSON.parse(field.params)
        break;
      case "file":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=this.default_file_params;
        else
          field.params=JSON.parse(field.params);
        break;
      case "photo":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params= this.default_photo_params;
        else
          field.params=JSON.parse(field.params);
        break;

      case "address":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=this.default_addresses_params;
        else
          field.params=JSON.parse(field.params);
        break;

      case "document":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=this.default_documents_params;
        else
          field.params=JSON.parse(field.params);
        break;

      case "table":
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params=[];
        else
          try{
       
            if(!Array.isArray(field.params))
              field.params=JSON.parse(field.params);
            
          }catch{
            field.params=[];
          }
        break;
      default:
        if(field.params=="" || field.params==null || field.params==undefined)
          field.params= [];
        break;
    }
  }



  /** CASELLA DI RIEPILOGO */
  addValueToParams(field:any){
   
    if(!field.params){
      field.params=[];
    }else{
      try{
        if(typeof(field.params)=="string")
          field.params=JSON.parse(field.params);
      }catch{
        field.params=[];
      }
      
    }
    let value=prompt("Indicare il valore dell'elemento","");
    if(value){
      field.params.push(value);
    }
  }

  removeValueFromParams(field:any){
    if(!field.params){
      field.params=[];
    }else{
      if(typeof(field.params)=="string")
        field.params=field.params.split(";");
    }

    for(let i=0;i<field.params.length;i++){
      if(field.params[i]==this.param_selected){
        field.params.splice(i,1);
        this.param_selected="";
        return;
      }
    }
  }




   isArray(obj:any){
    return Array.isArray(obj);
  }

   typeCode(t) {
    return '{{'+t+'}}'
  }
  
  parseAccess(access:string){
    
    if(access=="all"){
      return "all";
    }

    if(access==""){
      return "";
    }
    
    try{
      if(!this.isArray(this.f.access))
        this.f.access=JSON.parse(this.f.access);
      
    }catch{
      this.setAccess(this.f);
    }
    
    return "custom";
  }

  setAccess(item:any){
    if(item.access_mode=='custom'){
      item.access=[];
      for(let ug of this.usersgroups){
        item.access.push({"group":ug.name,"permission":"all"});
      }
    }else{
      item.access=item.access_mode;
    }
  }


  openAccessModal(){
    this.modalAccessListRef=this.modalService.open(this.modalAccessList);
  }

  closeAccessModal(){
    this.modalAccessListRef.close("success");
  }
}
